import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Children, isValidElement, cloneElement, createContext, useState } from 'react';
import { useTranslations } from '../../hooks/useTranslations';
import faqsAnswersTranslations from 'i2l?query=sporks!pricing-pages-ui/lang/faqsAnswers/en.lyaml';
import { defaultTranslationsStatus } from '../../interfaces/TranslationsContext';
import { Section, SectionHeader, SectionTitle } from '../common/SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TranslationsContext = /*#__PURE__*/createContext(defaultTranslationsStatus);
const QuestionContent = styled.div.withConfig({
  displayName: "Faq__QuestionContent",
  componentId: "a75vqz-0"
})(["z-index:1;position:relative;"]);
const Faq = ({
  children
}) => {
  const [shouldLoadTranslations, setShouldLoadTranslations] = useState(false);
  const {
    isReady
  } = useTranslations(faqsAnswersTranslations, shouldLoadTranslations);
  const handleLoadTranslations = () => {
    if (!shouldLoadTranslations) {
      setShouldLoadTranslations(true);
    }
  };
  const childrenWithProps = Children.map(children, child => {
    if ( /*#__PURE__*/isValidElement(child)) {
      return /*#__PURE__*/cloneElement( /* Replace with QuestionProps once Question.js is typed */
      child, {
        onQuestionClick: handleLoadTranslations
      });
    }
    return child;
  });
  return /*#__PURE__*/_jsx(Section, {
    "data-selenium-id": "faq-container",
    children: /*#__PURE__*/_jsxs(QuestionContent, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        children: /*#__PURE__*/_jsx(SectionTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "faq.title"
          })
        })
      }), /*#__PURE__*/_jsx(TranslationsContext.Provider, {
        value: {
          isReady
        },
        children: childrenWithProps
      })]
    })
  });
};
export default Faq;